import TowerIcon from '@/components/brand/TowerIcon'
import { Button, Container, Group, Text, Title } from '@mantine/core'
import { IconHome } from '@tabler/icons-react'
import { Link } from '@tanstack/react-router'
import { Illustration } from './Illustration'
import classes from './NotFoundPage.module.css'

export function NotFoundPage() {
  return (
    <Container className={classes.root}>
      <div className={classes.inner}>
        <Illustration className={classes.image} />
        <div className={classes.content}>
          <TowerIcon className={classes.towerIcon} />
          <Title className={classes.title}>Nothing to see here</Title>
          <Text c="dimmed" size="md" ta="center" className={classes.description}>
            Page you are trying to open does not exist. You may have mistyped the address, or the
            page has been moved to another URL. If you think this is an error contact support.
          </Text>
          <Group justify="center">
            <Button
              size="md"
              component={Link}
              to="/"
              leftSection={<IconHome size={20} stroke={1.5} />}
            >
              Go back to home page
            </Button>
          </Group>
        </div>
      </div>
    </Container>
  )
}
